import { render, staticRenderFns } from "./Ranking&search.vue?vue&type=template&id=448dd85e&scoped=true&"
import script from "./Ranking&search.vue?vue&type=script&lang=js&"
export * from "./Ranking&search.vue?vue&type=script&lang=js&"
import style1 from "./Ranking&search.vue?vue&type=style&index=1&id=448dd85e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448dd85e",
  null
  
)

export default component.exports